<div class="mt-5 mb-5 d-flex mt-5">
  <div class="text-center">
    <span class="icon-custom-height" [inlineSVG]="'assets/images/icons/icon-desktop.svg'"></span>

    <div class="doughnut d-flex flex-column mt-4">
      <canvas
        baseChart
        [data]="doughnutDesktopData"
        [labels]="doughnutLabels"
        [options]="doughnutOptions"
        [legend]="doughnutLegend"
        [type]="doughnutType"
      >
      </canvas>
      <div class="percent">
        <div class="test">{{ desktop?.percentage }}%</div>
      </div>
      <div class="align-self-center">
        <div class="text-center" translate>stats_pages_devices_percent_title_desktop</div>
        <div class="text-center clicks mt-2">{{ desktop?.clicks ? desktop.clicks : 0 }}</div>
        <div class="text-center" translate>stats_pages_details_device_views</div>
      </div>
    </div>
  </div>

  <div class="text-center">
    <span class="icon-custom-height" [inlineSVG]="'assets/images/icons/icon-smartphone.svg'"></span>
    <div class="doughnut d-flex flex-column mt-4">
      <canvas
        baseChart
        [data]="doughnutSmartphoneData"
        [labels]="doughnutLabels"
        [options]="doughnutOptions"
        [legend]="doughnutLegend"
        [type]="doughnutType"
      >
      </canvas>
      <div class="percent">
        <div class="test">{{ smartphone?.percentage ? smartphone.percentage : 0 }}%</div>
      </div>
      <div class="align-self-center">
        <div class="text-center" translate>stats_pages_devices_percent_title_smartphone</div>
        <div class="text-center clicks mt-2">{{ smartphone?.clicks ? smartphone.clicks : 0 }}</div>
        <div class="text-center" translate>stats_pages_details_device_views</div>
      </div>
    </div>
  </div>

  <div class="text-center">
    <span class="icon-custom-height" [inlineSVG]="'assets/images/icons/icon-tablet.svg'"></span>
    <div class="doughnut d-flex flex-column mt-4">
      <canvas
        baseChart
        [data]="doughnutTabletData"
        [labels]="doughnutLabels"
        [options]="doughnutOptions"
        [legend]="doughnutLegend"
        [type]="doughnutType"
      >
      </canvas>
      <div class="percent">
        <div class="test">{{ tablet?.percentage ? tablet.percentage : 0 }}%</div>
      </div>

      <div class="align-self-center">
        <div class="text-center" translate>stats_pages_devices_percent_title_tablet</div>
        <div class="text-center clicks mt-2">{{ tablet?.clicks ? tablet.clicks : 0 }}</div>
        <div class="text-center" translate>stats_pages_details_device_views</div>
      </div>
    </div>
  </div>

  <div>
    <div class="d-flex flex-row justify-content-center" style="height: 140px;">
      <div class="d-flex flex-column justify-content-between">
        <span class="icon" [inlineSVG]="'assets/images/icons/icon-tv.svg'"></span>
        <span class="icon" [inlineSVG]="'assets/images/icons/icon-camera.svg'"></span>
        <span class="icon" [inlineSVG]="'assets/images/icons/icon-music.svg'"></span>
      </div>

      <div class="d-flex flex-column justify-content-between">
        <span class="icon" [inlineSVG]="'assets/images/icons/icon-car.svg'"></span>
        <span class="icon" [inlineSVG]="'assets/images/icons/icon-phone.svg'"></span>
        <span class="icon" [inlineSVG]="'assets/images/icons/icon-gamepad.svg'"></span>
      </div>
    </div>
    <div class="doughnut d-flex flex-column mt-4">
      <canvas
        baseChart
        [data]="doughnutOthersData"
        [labels]="doughnutLabels"
        [options]="doughnutOptions"
        [legend]="doughnutLegend"
        [type]="doughnutType"
      >
      </canvas>
      <div class="percent">
        <div class="test">{{ other?.percentage ? other.percentage : 0 }}%</div>
      </div>
      <div class="align-self-center">
        <div class="text-center" translate>stats_pages_devices_percent_title_other</div>
        <div class="text-center clicks mt-2">{{ other?.clicks ? other.clicks : 0 }}</div>
        <div class="text-center" translate>stats_pages_details_device_views</div>
      </div>
    </div>
  </div>
</div>

<div class="">
  <table class="table">
    <thead>
      <tr>
        <th translate>stats_pages_details_device_title</th>
        <th class="text-center" translate>stats_pages_details_device_views</th>
        <th class="text-end" translate>stats_richsms_details_percent</th>
      </tr>
    </thead>
    <tbody *ngIf="this.campainStats.os">
      <tr *ngFor="let os of this.campainStats.os | keyvalue">
        <td class="left-column">{{ os.key }}</td>
        <td class="center-column views">{{ os.value.clicks }}</td>
        <td class="right-column">{{ os.value.percentage }}%</td>
      </tr>
    </tbody>
  </table>
</div>
